import { getSetting } from './settings';

const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'CHF ',
  SEK: 'kr ',
  NOK: 'kr ',
  DKK: 'kr ',
};

export function formatCost(cost) {
  if (cost == null || cost === 0) return 'Free';
  const currency = getSetting('wanderologie_settings.currency') || 'USD';
  const symbol = CURRENCY_SYMBOLS[currency] || '$';
  return `${symbol}${cost}`;
}
